import styled from 'styled-components';

export const Container = styled.section<{$fullWidth: boolean, $summaryMobileIsOpen: boolean}>`
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    width: ${({ $fullWidth }) => $fullWidth ? '100%' : '787px'};

    @media (max-width: 1200px) {
        padding-bottom: ${({ $summaryMobileIsOpen }) => $summaryMobileIsOpen ? 'calc(4rem + 206px)' : '4rem'};
    }
`;

export const WrapperContent = styled.section<{$showStartImage: boolean}>`
    display: grid;
    width: 100%;
    gap: 16px;
    grid-template-columns: ${({ $showStartImage }) => $showStartImage ? '1.2fr 1fr' : '1fr'};

    @media (max-width: 1200px) {
        display: flex;
        padding: 24px;
        gap: 8px;
        flex-direction: column;
    }
`;

export const WrapperStartImage = styled.section`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    max-height: 470px;
    border-radius: 16px;

    @media (max-width: 1200px) {
        max-height: 250px;
    }
`;

export const WrapperControles = styled.section`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 5px;
    bottom: 15px;
`;

export const ContainerImage = styled.section`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
    background-color: #f5f5f5;
    border: ${({ theme }) => `1px solid ${theme.colors.border}`};
    border-radius: 8px;
    
    .image-zoom {
        background-color: red;
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;

export const WrapperAcordeon = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: calc(100vh - 335px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0px 2px;
`;

export const ControlButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: transparent;
    cursor: pointer;
    padding: 0;

    &:hover {
        background-color: transparent;
    }
`;

export const MobileListTitle = styled.h3`
    font-weight: 700;
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: 16px;
`;

export const RedirectText = styled.span`
    color: ${({ theme }) => theme.colors.accent.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
`;

export const BackToSessionListContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
`;

export const RightContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;

    h3 {
        font-family: 'Elza', sans-serif;
        font-weight: 700;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.text.primary};
    }

    span {
        color: ${({ theme }) => theme.colors.button.text.disabled};
        font-size: 12px;
        font-weight: 500;
    }
`;
